import { CUSTOM_FILTERS } from "@/config/list";
export function getSearchParamForRequest(search?: string) {
	const trimmed = search?.trim();
	return trimmed ? { "filter[search]": trimmed } : {};
}

export function getTableSearchParam(filters?: any[]) {
	const search = filters?.find(f => f.id === CUSTOM_FILTERS.search)?.value as string | undefined;

	return search?.trim() || undefined;
}

export interface StructureFilterParams {
	structureGroupIds?: string[];
	structureTypeIds?: string[];
	structureIds?: string[];
	networkType?: Dryp.NetworkType;
	search?: string;
	hasConnectivity?: boolean;
	isMostDownstream?: boolean;
	downstreamStructureId?: Dryp.StructureId;
	hasData?: boolean;
	isFullyConfiguredForIAndI?: boolean;
	isActive?: boolean;
}

export const getTableStructureFilterParams = (filters?: any[]): StructureFilterParams => {
	const structureGroupIds = filters?.find(f => f.id === CUSTOM_FILTERS.structureGroupIds)?.value as
		| string[]
		| undefined;

	const structureTypeIds = filters?.find(f => f.id === CUSTOM_FILTERS.structureTypesIds)?.value as
		| string[]
		| undefined;

	const structureIds = filters?.find(f => f.id === CUSTOM_FILTERS.structureIds)?.value as string[] | undefined;

	const networkType = filters?.find(f => f.id === CUSTOM_FILTERS.networkType)?.value;

	const isMostDownstream = filters?.find(f => f.id === CUSTOM_FILTERS.isMostDownstream)?.value as boolean | undefined;

	const hasData = filters?.find(f => f.id === CUSTOM_FILTERS.hasData)?.value as boolean | undefined;

	const isFullyConfiguredForIAndI = filters?.find(f => f.id === CUSTOM_FILTERS.isFullyConfiguredForIAndI)?.value as
		| boolean
		| undefined;

	const isActiveFilter = filters?.find(f => f.id === CUSTOM_FILTERS.isActive)?.value as string | undefined;
	const isActive = isActiveFilter === "all" ? undefined : isActiveFilter === "inactive" ? false : true;

	const search = getTableSearchParam(filters);

	return {
		structureGroupIds,
		structureTypeIds,
		structureIds,
		networkType,
		isMostDownstream,
		hasData,
		isFullyConfiguredForIAndI,
		isActive,
		search,
	};
};

export const getStructureFilterParamsForRequst = (structureParams: StructureFilterParams) => {
	const params: Record<string, unknown> = {};

	if (structureParams.structureGroupIds && structureParams?.structureGroupIds.length > 0) {
		params["filter[structureGroupIds]"] = structureParams.structureGroupIds;
	}

	if (structureParams.structureTypeIds && structureParams.structureTypeIds.length > 0) {
		params["filter[structureTypeIds]"] = structureParams.structureTypeIds;
	}

	if (structureParams.structureIds && structureParams.structureIds.length > 0) {
		params["filter[structureIds]"] = structureParams.structureIds;
	}

	if (structureParams.networkType && structureParams.networkType?.length > 0) {
		params["filter[structureNetworkTypes]"] = structureParams.networkType;
	}

	if (structureParams.hasConnectivity !== undefined) {
		params["filter[hasConnectivity]"] = structureParams.hasConnectivity;
	}

	if (structureParams.isMostDownstream !== undefined) {
		params["filter[isMostDownstream]"] = structureParams.isMostDownstream;
	}

	if (structureParams.hasData !== undefined) {
		params["filter[hasData]"] = structureParams.hasData;
	}

	if (structureParams.isFullyConfiguredForIAndI !== undefined) {
		params["filter[isFullyConfiguredForIAndI]"] = structureParams.isFullyConfiguredForIAndI;
	}

	if (structureParams.isActive !== undefined) {
		params["filter[isActive]"] = structureParams.isActive;
	}

	if (structureParams.downstreamStructureId !== undefined) {
		params["filter[downstreamStructureId]"] = structureParams.downstreamStructureId;
	}

	return { ...params, ...getSearchParamForRequest(structureParams.search) };
};
